import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  createFilter
  
} from "@/components/charts/common";

import pluralize from 'pluralize';


function resolve(path, obj) {
  return path.split('.').reduce(function(prev, curr) {
    return prev ? prev[curr] : null
  }, obj || self)
}

function getLevel1(headers) {

}

function getHeaders(headers) {

}


export default async function hydrator(parameters, data, chart) {

  // alert("w");
  let options = {};

  options.chart = {};
  options.chart.sparkline = {enabled: true};

  options.chart.id = chart.id;
  options.dataLabels = {
    enabled: false
  };
  data.colors = ['#F54355', '#C1BEC7', '#FF0814', '#151821', '#857A89'];
  data.colors = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];
  data.gradient = ['#FA8F13', '#EE2C1F', '#6A7785', '#283BD1', '#454E5D'];

 //console.log("full parameters", parameters);
  if (typeof parameters.colorGradient.item.color != "undefined" && parameters.colorGradient.item.color) {
    data.colors = parameters.colorGradient.item.color.split(":");
  }

/**
  if (typeof parameters.lineColorGradient.item.id != "undefined" && parameters.lineColorGradient.item.id) {
    data.gradient = parameters.lineColorGradient.item.color.split(":");
  }**/

  data.canvasStyle = {
  //   borderBottom: "10px solid " + data.colors[0],
    //height: "180px",
    width: "100%"
  };

data.activeCanvasStyle = {
  //  borderBottom: "0px solid #fff",
  //  height: "180px",
    width: "100%"
  };

  data.fontStyle = {
    padding: '10px 20px 0 20px',
    width: "100%",
    color: data.colors[0]
  };

  data.activeFontStyle = {
    padding: '10px 20px 0 20px',
    width: "100%",
    color: "#fff"
  };


  data.fontClass = ['text-xs-right'];

  //
  // data.aggregateKey = 'sum';
  // if (typeof parameters.aggregateData.value != "undefined" && parameters.aggregateData.value) {
  //   data.aggregateKey = parameters.aggregateData.value;
  // }

  data.format = '0,0.[00]';
  if (typeof parameters.formatSource.value != "undefined" && parameters.formatSource.value) {
    data.format = parameters.formatSource.value;
  }

  data.currency = parameters.currency.value;
  data.displaySparkline = true;

  if (typeof parameters.displaySparklineSource.value != "undefined") {
    data.displaySparkline = parameters.displaySparklineSource.value;
  }

  const gridHeight = chart.grid.h;
  const layoutHeight = chart.grid.layout.rowHeight;
  const realHeight = (layoutHeight * gridHeight) * 1.45;
  data.height = realHeight;

  const gridWidth = chart.grid.w;
  //console.log("gridWidth", gridWidth);

  // console.log(chart.grid.w);
  let chartDataSource = parameters.chartDataSource;
  let items = parameters.chartDataSource.items;


  for(let i = 0; i < items.length; i++) {
    await items[i].update(true);
    // console.log("chartDataSource", items[i]);
  }

  if(!chartDataSource.item.data.length && items.length) {
    chartDataSource.item = items[0];
    chartDataSource.value = items[0].id;
  }

  // parameters.chartDataSource.getValue();

  //console.log("chartDataSource.item.fullQuery", chartDataSource.item.fullQuery);


  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  // console.log('fullQuery', fullQuery);
  query.id = chartDataSource.item.id;
  // "strftime('%Y %m', `date`)"

  let _group = resolve("groupData.value", parameters);
  let _item = resolve("itemData.value", parameters);
  let _transformItem = resolve("transformItemData.value", parameters);
  data.transformItem = pickItem(parameters.transformItemData);
  let _value = resolve("valueData.value", parameters);
  let _transformValue = resolve("transformValueData.value", parameters);
  let _orientationValue = resolve("orientationData.value", parameters);

  let customFilter = resolve("customFilter.value", parameters);

  const groupItem = null;
  const itemItem = pickItem(parameters.itemData);
  const valueItem = pickItem(parameters.valueData);

  let metric = _value;

  _group = "''";
  _item = _item ? _item : _group;

  // console.log("items:" + _item + ":");

  // _group = _group ? _group : _item;
//  _item = _item ? _item : null;

  if(_item) {
    _item = _transformItem.replace("field", _item);
  }

  if(_value) {
    _value = _transformValue.replace("field", _value);
  }



  // console.log("parameters", parameters);
  // console.log("_item", _item);
  // console.log("_value", _value)

  let _filters = resolve("tree.filters", chart);
  let filters = _filters ? Object.values(_filters) : [];



  query.sql = createSQL(fullQuery, _group, _item, _value, filters, _transformValue, customFilter);
  // console.log("query summary", query);
  let dd = await chartDataSource.item.request(query);
  chart.response = dd;
  // console.log("chart.response", chart.response);

  if(dd.data.length > 10000) {
    return false;
  }


  // console.log('chartDataSource.item', chartDataSource.item);
  // data = {...data,  ...{series: createSeries(chartDataSource.item.data)}};
  let series = createSeries(dd.data);
  if(series.length) {
    // series[0].name = resolve("title.value", parameters);
  }
  // console.log("series", series);
  options.series = Object.freeze(series);

  data.title = resolve("title.value", parameters);
  data.sparklineType = resolve("sparklineType.value", parameters);

  data.metric = valueItem.text;
  data.orientation = _orientationValue;
  data.group = _group;
  data.activeFilter = resolve("filterSource.value", parameters);

  data.series = series;
  const l = data.series.length;
  data.sizes = 'xs12';
  if(gridWidth <= 5) {
    data.sizes = 'xs12';
  } else if(gridWidth < 9) {
    data.sizes = 'xs6';
  } else {
    const d = 12/l;
    data.sizes = 'xs4';
  }

  if (series.length) {

    data.options = options;



    // console.log("data.options", data.options);
    data.valid = true;
    if (typeof chart.instance != 'undefined' && chart.instance) {
      // console.log('chart.instance', 'exist');
      //
      // chart.instance.updateSeries(series, false, true);
      chart.instance.updateOptions(options, true, true);
      //console.log('series', series);
      // chart.instance.refresh();
      // console.log('chart.instance', chart.instance);
    } else {
      //  console.log('chart.instance', 'not set');
    }
  }
  // console.log("number sparkline", data);
}
